import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { getRootURL } from 'utils/helpers';
import LogoutButton from 'components/Creditea/Core/PageHeader/LogoutButton';
import { FormattedHTMLMessage } from 'react-intl';

const PageHeader = (props, context) => {
  const { toggle, click2CallAvailable } = props;

  const headerStyles = {};

  let logo;

  if (EMBEDDED) {
    const { params } = props;
    logo = (
      <span
        className="page-header__logo hide-text"
        style={{ backgroundImage: `url(${params.logoUrl})` }}
      />
    );
    if (params.headerBackgroundColor) {
      headerStyles.backgroundColor = params.headerBackgroundColor;
    }
  } else {
    const logoClasses = cx({
      'page-header__logo': true,
      'hide-text': true,
      'page-header__logo--hapi': COUNTRY === 'PL',
      'page-header__logo--creditea': COUNTRY === 'MX' || COUNTRY === 'ES' || COUNTRY === 'CZ',
    });
    const link = getRootURL(context.intl.locale);
    logo = <a href={link} className={logoClasses}>Creditea</a>;
  }

  const headerClasses = cx({
    'page-header': true,
    'page-header--embedded': EMBEDDED,
    'page-header--pl': COUNTRY === 'PL',
    'page-header--mx': COUNTRY === 'MX',
  });

  const headerContainerClasses = cx({
    container: true,
    clearfix: COUNTRY !== 'ES',
    'page-header--flex': COUNTRY === 'ES',
  });

  return (
    <header className={headerClasses} style={headerStyles}>
      <div className={headerContainerClasses}>
        {logo}
        {COUNTRY === 'ES'
        && (
        <h4 className="txt-center page-header__contact">
          <FormattedHTMLMessage id="header.contact.number" />
        </h4>
        )}
        {!VERIFICATION_APP && <LogoutButton {...props} />}
        {COUNTRY === 'PL' && <span className="page-header__cloud" />}
        {click2CallAvailable
          && (
          <button className="hide-desktop support support--in-header pull-right" onClick={() => toggle('help')}>
            <span className="support--in-header__icon icon icon--phone" />
          </button>
          )}
      </div>
    </header>
  );
};

PageHeader.propTypes = {
  params: PropTypes.object,
  click2CallAvailable: PropTypes.bool,
  toggle: PropTypes.func,
};
PageHeader.contextTypes = {
  intl: PropTypes.object,
};

export default PageHeader;
